class PrimaryNav {
  constructor() {
    this.navLinks = document.querySelectorAll('.nav__links-item');
    this.bindEvents();
  }

  bindEvents() {
    this.navLinks.forEach(link => {
      // Add event listeners if nav link has submenu
      if (link.querySelector('.nav__dropdown')) {
        link.addEventListener('mouseenter', this.onDropdownExpand);
        link.addEventListener('mouseleave', this.onDropdownCollapse);
        link.addEventListener('focusin', e => this.onDropdownExpand(e, link));
        link.addEventListener('focusout', e => this.onDropdownCollapse(e, link));
      }
    });
  }

  onDropdownExpand(e, dropdownParent = null) {
    if (dropdownParent) {
      dropdownParent.setAttribute('aria-expanded', 'true');
    } else {
      e.target.setAttribute('aria-expanded', 'true');
    }
  }

  onDropdownCollapse(e, dropdownParent = null) {
    if (dropdownParent) {
      dropdownParent.setAttribute('aria-expanded', 'false');
    } else {
      e.target.setAttribute('aria-expanded', 'false');
    }
  }
}

export default PrimaryNav;
